import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { atualizarUsuarioDoDistribuidor, obterUsuarioDistribuidor } from "../services/api";
import CadastroDistribuidorUsuario from "./CadastroDistribuidorUsuario";

const EditarDistribuidorUsuario = ({ token }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const distribuidorId = searchParams.get("distribuidorId") || "";
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    obterUsuarioDistribuidor(id, token)
      .then((r) => setInitialData(r.data))
      .catch(() => alert("Erro ao carregar usuário."));
  }, [id, token]);

  const handleSubmit = async (data) => {
    await atualizarUsuarioDoDistribuidor(data.distribuidorId, id, data, token);
  };

  if (!initialData) return <div className="p-6">Carregando...</div>;

  return (
    <CadastroDistribuidorUsuario
      token={token}
      initialData={initialData}
      onSubmit={handleSubmit}
      isEdit
      distribuidorIdFromQuery={distribuidorId}
    />
  );
};

export default EditarDistribuidorUsuario;
